import { Config } from '@cvx/cal';

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'localStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '7a0de2a6-25f0-4761-9f8f-ef509c74aefe',
  redirectUri: 'https://caira-stage.azure.chevron.com',
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
};

export const environment = {
  calConfig: calConfig,
  production: false,
  envName: 'stage',
  requestTimeout: 30000,
  apiEndpoint: 'https://caira-api-stage-cvx.azurewebsites.net',
  redirectUri: 'https://caira-stage.azure.chevron.com',
};